export const selectorLocation = '.b-location'
export const selectorLocationCopy = '.b-pnum.b-location-copy'
export const classNoteActive = 'b-note__active'
export const selectorEndnoteAnchor = '.b-note.b-endnote'
export const selectorEndnoteReturnToText = '.b-returntotext'
export const selectorGlossaryReferenceAnchor = '.b-note.b-glossary-reference'
export const appBarHeight = 48
export const appBarHeightWork = 44
export const textTagsSelector = 'h1, h2, h3, h4, h5, h6, p'
